import React from 'react'
import { Card as SCard } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import Card from '../card/card'
import styles from './card-group.module.css'
import IntelMsg from '../ItelMsg/index'

const CardGroup = ({ items }) => {
  const { userRole } = useSelector((store) => ({
    userRole: store.auth.userRole,
  }))
  return (
    <div className={styles.groupContainer}>
      {/* <SCard.Group stackable doubling itemsPerRow={3} className={styles.group}> */}
      <SCard.Group className={styles.group}>
        {items.map((item) => {
          console.log('item', item)
          const roles = item.role.split(',')
          if (roles.includes(userRole)) {
            return (
              <Card
                key={item.name}
                title={<IntelMsg id={item.name} />}
                color={item.color}
                iconName={item.icon}
                to={item.to !== '/user/management' ? item.to : null}
              />
            )
          }
          return ''
        })}
      </SCard.Group>
    </div>
  )
}

CardGroup.propTypes = {
  items: PropTypes.array,
}

export default CardGroup
